export const ONBOARDING_STEPS = [
  {
    id: 1,
    label: "Organization",
    hint: "Name, contact, and address",
    path: "/signup/profile-step-one",
  },
  {
    id: 2,
    label: "Availability",
    hint: "Public link and working hours",
    path: "/signup/profile-step-two",
  },
  {
    id: 3,
    label: "Preferences",
    hint: "Your role and event types",
    path: "/signup/profile-step-three",
  },
  {
    id: 4,
    label: "Invite",
    hint: "Optional — invite a team member",
    path: "/signup/profile-step-four",
  },
];

export const ADMIN_SETUP_STEPS = [
  {
    id: 1,
    label: "Organization",
    hint: "Name, contact, and address",
    path: "/admin/quick-setup-step-one",
  },
  {
    id: 2,
    label: "Availability",
    hint: "Public link and working hours",
    path: "/admin/quick-setup-step-two",
  },
  {
    id: 3,
    label: "Preferences",
    hint: "Your role and event types",
    path: "/admin/quick-setup-step-three",
  },
];

export const ONBOARDING_STORAGE = {
  companyId: "onboarding_company_id",
  companyName: "onboarding_company_name",
};

export const WEEKDAYS = [
  { id: 1, short: "Mon", label: "Monday" },
  { id: 2, short: "Tue", label: "Tuesday" },
  { id: 3, short: "Wed", label: "Wednesday" },
  { id: 4, short: "Thu", label: "Thursday" },
  { id: 5, short: "Fri", label: "Friday" },
  { id: 6, short: "Sat", label: "Saturday" },
  { id: 7, short: "Sun", label: "Sunday" },
];

export const getOnboardingCompanyId = () => {
  try {
    return sessionStorage.getItem(ONBOARDING_STORAGE.companyId) || "";
  } catch (error) {
    return "";
  }
};

export const getOnboardingCompanyName = () => {
  try {
    return sessionStorage.getItem(ONBOARDING_STORAGE.companyName) || "";
  } catch (error) {
    return "";
  }
};

export const setOnboardingCompany = (id, name) => {
  try {
    if (id) {
      sessionStorage.setItem(ONBOARDING_STORAGE.companyId, String(id));
    }
    if (name) {
      sessionStorage.setItem(ONBOARDING_STORAGE.companyName, String(name));
    }
  } catch (error) {
    // sessionStorage can be blocked in private mode
  }
};

export const getStepTwoPath = () => {
  const id = getOnboardingCompanyId();
  return id ? `/signup/profile-step-two/${id}` : "/signup/profile-step-one";
};

export const getStepPath = (stepId) => {
  if (stepId === 2) {
    return getStepTwoPath();
  }
  const step = ONBOARDING_STEPS.find((item) => item.id === stepId);
  return step ? step.path : "/signup/profile-step-one";
};

export const slugifyOrganisation = (name) => {
  if (!name) {
    return "";
  }
  const slug = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 48);
  return slug;
};

export const getLocaleFirstWeekday = () => {
  try {
    const locale = new Intl.Locale(navigator.language || "en");
    const firstDay = locale.weekInfo?.firstDay;
    if (firstDay >= 1 && firstDay <= 7) {
      return firstDay;
    }
  } catch (error) {
    // Intl.Locale.weekInfo is not available in every browser
  }
  return 1;
};

export const getLocaleTimeFormat = () => {
  try {
    const cycle = new Intl.DateTimeFormat(undefined, {
      hour: "numeric",
    }).resolvedOptions().hourCycle;
    return cycle === "h12" || cycle === "h11" ? "12" : "24";
  } catch (error) {
    return "24";
  }
};

export const getLocalePhoneCountry = () => {
  try {
    const region = new Intl.Locale(navigator.language || "en")
      .maximize()
      .region;
    if (region) {
      return region.toLowerCase();
    }
  } catch (error) {
    // fall through
  }
  return "us";
};

export const orderWeekdays = (firstDay) => {
  const index = WEEKDAYS.findIndex((day) => day.id === Number(firstDay));
  if (index <= 0) {
    return WEEKDAYS;
  }
  return [...WEEKDAYS.slice(index), ...WEEKDAYS.slice(0, index)];
};

export const isOtherProfession = (item) =>
  Boolean(item && /other/i.test(String(item.profession || "")));

export const isOtherEventType = (item) =>
  Boolean(
    item &&
      (String(item.id) === "9" || /other/i.test(String(item.event_type || "")))
  );
